import { defaultZkSyncProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/zksync/default-constants';

export const MUTE_SWAP_CONTRACT_ADDRESS = '0x8B791913eB07C32779a16750e3868aA8495F5964';

export const MUTE_SWAP_PROVIDER_CONFIGURATION = defaultZkSyncProviderConfiguration;
